/**
 * @graphql cc
 */
import gql from 'graphql-tag';
import {
	// eslint-disable-next-line graphql-relay-compat/no-import-apollo-functions -- Read http://go/cfe-no-import-apollo-functions
	useQuery,
} from 'react-apollo';

import { getExternalCollaboratorEntitlementFromQuery } from '@confluence/external-collab-ui/entry-points/getExternalCollaboratorEntitlementFromQuery';

import type { useIsEntitledExternalCollaboratorUserAndGroupSearchPickerQuery as useIsEntitledExternalCollaboratorUserAndGroupSearchPickerQuery$data } from './__types__/useIsEntitledExternalCollaboratorUserAndGroupSearchPickerQuery';

export const useIsEntitledExternalCollaborator = ({ skip = false }: { skip?: boolean } = {}) => {
	const { loading, data } =
		useQuery<useIsEntitledExternalCollaboratorUserAndGroupSearchPickerQuery$data>(
			gql`
				query useIsEntitledExternalCollaboratorUserAndGroupSearchPickerQuery {
					entitlements {
						externalCollaborator {
							isEntitled
						}
					}
				}
			`,
			{
				skip,
			},
		);
	return {
		isEntitledExternalCollaboration: getExternalCollaboratorEntitlementFromQuery(data) ?? false,
		loading,
	};
};
